const VERY_LOW = "VERY_LOW";
const LOW = "LOW";
const BELLOW_MEDIUM = "BELLOW_MEDIUM";
const MEDIUM = "MEDIUM";
const HIGH = "HIGH";
const VERY_HIGH = "VERY_HIGH";

export const probabilityThresholds = [
  { tag: VERY_LOW, threshold: 0 },
  { tag: LOW, threshold: 0.1 },
  { tag: BELLOW_MEDIUM, threshold: 0.25 },
  { tag: MEDIUM, threshold: 0.5 },
  { tag: HIGH, threshold: 0.75 },
  { tag: VERY_HIGH, threshold: 0.9 },
];

const getProbabilityTag = (probability) => {
  if (probability == null) return null;
  if (typeof probability != "number") return null;
  let tag;
  probabilityThresholds.forEach((probabilityThreshold) => {
    if (probability >= probabilityThreshold.threshold) {
      tag = probabilityThreshold.tag;
    }
  });
  return tag;
};

export default getProbabilityTag;
